import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SocialMediaInstallationStatuses } from '@sb-tools/typescript/models/social-media-installation-statuses.dto';
import { environment } from '@environment';
import { shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SocialMediaService {
    private statuses$: Observable<SocialMediaInstallationStatuses>;

    constructor(private httpClient: HttpClient) {}

    get(): Observable<SocialMediaInstallationStatuses> {
        if (!this.statuses$) {
            this.statuses$ = this.httpClient
                .get<SocialMediaInstallationStatuses>(environment.apiInboxUrl + 'SocialMedia/Statuses/')
                .pipe(shareReplay());
        }

        return this.statuses$;
    }
}
